import { render } from "./DepartmentalStructure.vue?vue&type=template&id=3073fb40&ts=true"
import script from "./DepartmentalStructure.vue?vue&type=script&lang=tsx"
export * from "./DepartmentalStructure.vue?vue&type=script&lang=tsx"

import "./DepartmentalStructure.vue?vue&type=style&index=0&id=3073fb40&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__